module.exports = __webpack_public_path__ + "static/media/star_dron-z_90.7311a477.png";